const CONTROL_BUCKET = 'control';
const EXPERIMENT_BUCKET = 'experiment';

export { CONTROL_BUCKET, EXPERIMENT_BUCKET };